import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancelled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="mb-6">
          <XCircle className="h-16 w-16 text-gray-600 mx-auto" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Payment Cancelled
        </h1>

        <p className="text-gray-600 mb-8">
          Your payment was cancelled. Need help? Contact our support team.
        </p>

        {/* <div className="space-y-4">
          <button
            onClick={() => navigate("/driver/dashboard")}
            className="w-full flex items-center justify-center gap-2 bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Return to Dashboard
          </button>

          <button
            onClick={() => navigate("/driver/payments")}
            className="w-full flex items-center justify-center gap-2 bg-white border border-gray-300 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Try Again
          </button>
        </div> */}
      </div>
    </div>
  );
}
